import React, { Component } from "react";
import { connect } from "react-redux";
import * as selector from "../../../common/selectors";
import * as enrolGIRONowSelector from "../../../common/selectors/enrolGIRONow";
import * as enrolGIRONowAction from "../../../common/actions/enrolGIRONow";
import CustomBoardRenewal from "../../components/CustomBoardRenewal";
import { withStyles } from "@material-ui/core/styles";
import { withRouter } from "react-router-dom";
import CustomText, {
  getFontSize,
  getFontWeight,
} from "../../components/CustomText";
import Color from "../../../utils/Color";
import Grid from "@material-ui/core/Grid";
import CustomTextInput from "../../components/CustomTextInput";
import CustomButton from "../../components/CustomButton";
import _ from "lodash";
import AuthManager from "../../../utils/AuthManager";
import Image from "../../../assets";
import { Helmet } from "react-helmet";
import CustomBoardGiro from "../../components/CustomBoardGiro";
import CustomEnrolGiroNowV2 from "../../components/CustomEnrolGiroNowV2";
import LoadingOverlay from "../../components/LoadingOverlay";
import CustomPaper from "../../components/CustomPaper";
import Toolbar from "@material-ui/core/Toolbar";
import AppBar from "@material-ui/core/AppBar";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import CustomTextInputOtp from "../../components/CustomTextInputOtp";
import { DayPicker } from "react-day-picker";
import { format, parse } from "date-fns";
import CustomModal from "../../components/CustomModal";
import CustomToast from "../../components/CustomToast";

import * as registrationSelector from "../../../common/selectors/registration";
import * as registrationAction from "../../../common/actions/registration";
import { AutoTabProvider } from "react-auto-tab";

const screenW = "100vw";
const screenH = window.innerWidth < 640 ? "150vh" : "100vh";
const screenWHead = "100vw";
const screenHHead = "40vh";

class MovieEvent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      height: 0,
      width: 0,
      policyNo: "",
      isOnClickNext: false,
      error: false,
      errorMsg: "",
      firstRender: true,
      secondRender: false,
      thirdRender: false,
      forthRender: false,
      showCalander: false,
      selected: "",
      datePicked: "",
      localNric: "",
      errorMsgNRIC: "",
      errorMsgDOB: "",
      checkedA: false,
      customToastStatus: false,
      toastMessage: "",
      forthMsg: "",
      otp1: "",
      otp2: "",
      otp3: "",
      otp4: "",
      otp5: "",
      otp6: "",
      first: true,
      second: false,
      localOtpRef: "",
      showTerms: false,
      checkedB: false,
      localMaxLen: 1,
      showTermSub: false,
    };
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    this.updateWindowDimensions();
    window.addEventListener("resize", this.updateWindowDimensions);
    document.cookie.split(";").forEach(function (c) {
      document.cookie = c
        .replace(/^ +/, "")
        .replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/");
    });
    AuthManager.removeToken();
  }

  componentDidUpdate = (prevProps, prevState) => {
    if (prevProps.validateMovieRegData !== this.props.validateMovieRegData) {
      const data = registrationSelector.validateMovieRegDataData(
        this.props.validateMovieRegData
      );
      const status = registrationSelector.validateMovieRegDataStatus(data);
      const msg = registrationSelector.validateMovieRegDataMessage(data);
      const otpRef = registrationSelector.validateMovieRegDataOtpReference(
        data
      );
      this.setState({ localOtpRef: otpRef });
      if (status === 0) {
        this.setState({
          customToastStatus: true,
          toastMessage: msg,
        });
      }
      if (status === 1) {
        this.setState({
          secondRender: true,
          firstRender: false,
          checkedA: true,
        });
      }
      if (status === 2) {
        this.setState({ forthRender: true, firstRender: false, forthMsg: msg });
      }
      if (status === 3) {
        this.setState({ forthRender: true, firstRender: false, forthMsg: msg });
      }
      if (status === 4) {
        this.setState({ forthRender: true, firstRender: false, forthMsg: msg });
      }
      if (status === 5) {
        this.setState({ forthRender: true, firstRender: false, forthMsg: msg });
      }
      if (status === 6) {
        this.setState({
          customToastStatus: true,
          toastMessage: msg,
        });
      }
    }

    if (prevProps.submitMovieRegData !== this.props.submitMovieRegData) {
      const data = registrationSelector.submitMovieRegDataData(
        this.props.submitMovieRegData
      );
      const status = registrationSelector.submitMovieRegDataStatus(data);
      const msg = registrationSelector.submitMovieRegDataMessage(data);
      if (status === 0) {
        this.setState({
          customToastStatus: true,
          toastMessage: msg,
        });
      }
      if (status === 1) {
        this.setState({ secondRender: false, thirdRender: true });
      }
      if (status === 2) {
        this.setState({ forthRender: true, firstRender: false, forthMsg: msg });
      }
      if (status === 3) {
        this.setState({ forthRender: true, firstRender: false, forthMsg: msg });
      }
      if (status === 4) {
        this.setState({ forthRender: true, firstRender: false, forthMsg: msg });
      }
      if (status === 5) {
        this.setState({ forthRender: true, firstRender: false, forthMsg: msg });
      }
      if (status === 6) {
        this.setState({
          customToastStatus: true,
          toastMessage: msg,
        });
      }
    }
  };

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateWindowDimensions);
  }

  updateWindowDimensions() {
    this.setState({ width: window.innerWidth, height: window.innerHeight });
  }

  onChangePolicyNo = (event) => {
    this.setState({ policyNo: event.target.value });
  };

  onClickNext = () => {
    const { history } = this.props;
    const { policyNo } = this.state;
    this.setState({ isOnClickNext: true });
    // if (!this.validateTextInput()) {
    //   AuthManager.setPolicyNo(policyNo);

    //   history.push("/EnrolGiroInfo");
    // }
    // history.push("/EnrolGiroInfo");
    if (this.state.policyNo === "") {
    }
    const { getDDAPolicy } = this.props;
    if (this.state.policyNo === "") {
      this.setState({
        error: true,
        errorMsg: "You must specify a value for this required field.",
      });
    } else {
      getDDAPolicy(this.state.policyNo,"");
    }
  };

  onClickHere = () => {
    window.open(process.env.REACT_APP_LOGIN_BASE_URL);
  };

  validateTextInput = () => {
    const { policyNo } = this.state;
    return _.isEmpty(policyNo);
  };

  onClickBack = () => {
    window.history.back();
  };

  handleChangeCheckedA = () => {
    //this.setState({ checkedA: !this.state.checkedA,showTerms:true });
    if (this.state.showTerms === false && this.state.showTermSub === false) {
      this.setState({ showTerms: true });
    } else {
      this.setState({ checkedA: !this.state.checkedA });
    }
  };

  submitDetails = () => {
    if (this.state.localNric === "" || this.state.localNric.length < 4) {
      this.setState({
        error: true,
        errorMsgNRIC: "Please fill in last 4 digits of your NRIC.",
      });
      return;
    }

    if (this.state.datePicked === "") {
      this.setState({ errorMsgDOB: "Please select date of birth." });
      return;
    }

    if (!this.state.checkedA) {
      this.setState({
        customToastStatus: true,
        toastMessage: "Please check the terms and conditions.",
      });
      return;
    }

    var a =
      String(new Date(this.state.datePicked).getDate()).padStart(2, "0") +
      "/" +
      String(new Date(this.state.datePicked).getMonth() + 1).padStart(2, "0") +
      "/" +
      new Date(this.state.datePicked).getFullYear();
    console.log("datePicked", a);
    // this.setState({ firstRender: false, secondRender: true,error:false,errorMsgNRIC:"" });
    this.props.validateMovieReg(this.state.localNric, a);
    this.setState({ error: false, errorMsgNRIC: "" });
  };

  handleEnterOtp = () => {
    //this.setState({ secondRender: false, thirdRender: true });
    const { otp1, otp2, otp3, otp4, otp5, otp6, localOtpRef } = this.state;
    const a = otp1 + otp2 + otp3 + otp4 + otp5 + otp6;
    this.props.submitMovieReg(a, localOtpRef);
  };

  handleForthView = () => {
    //this.setState({ thirdRender: false, forthRender: true });
  };

  handleBackToTop = () => {
    this.setState({
      forthRender: false,
      firstRender: true,
      localNric: "",
      datePicked: "",
      checkedA: false,
    });
  };

  handleShowTerms = () => {
    this.setState({ showTerms: true, checkedA: !this.state.checkedA });
  };

  renderChildrenV1 = () => {
    const { classes } = this.props;
    const {
      policyNo,
      isOnClickNext,
      errorMsg,
      error,
      errorMsgNRIC,
      errorMsgDOB,
    } = this.state;
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          paddingLeft: window.innerWidth < 640 ? "5%" : "15%",
          paddingRight: window.innerWidth < 640 ? "5%" : "15%",
          paddingTop: "2%",
          fontFamily: "Arial",
        }}
      >
        <div
          style={{ color: "#262626", fontSize: "1.75rem", fontWeight: "600" }}
        >
          RSVP for WAKANDA FOREVER PREMIERE with ETIQA.
        </div>
        <div
          style={{
            color: "#262626",
            fontSize: "22px",
            fontWeight: "600",
            marginTop: 10,
          }}
        >
          We are excited and glad that you can join us!
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: window.innerWidth < 640 ? "column" : "row",
            justifyContent: "space-between",
            marginTop: 40,
            textAlign: "left",
          }}
        >
          <div
            style={{ display: "flex", flexDirection: "column", width: "100%" }}
          >
            <div
              style={{ marginBottom: 10, fontSize: "14px", fontWeight: "bold" }}
            >
              NRIC
            </div>
            <div>
              <CustomTextInput
                textstyle={classes.labelTextInputTextStyle}
                design={classes.textInputContainer}
                fullWidth={true}
                value={this.state.localNric}
                placeholder={"Last 4 characters e.g. 234B"}
                onChange={this.onChangeNRIC}
                errorMessage={errorMsgNRIC}
                error={errorMsgNRIC !== "" ? true : false}
              />
            </div>
          </div>
          <div style={{ marginLeft: 15, marginRight: 15 }}></div>
          <div
            style={{ display: "flex", flexDirection: "column", width: "100%" }}
          >
            <div
              style={{
                marginTop: window.innerWidth < 640 ? 15 : "",
                marginBottom: 10,
                fontSize: "14px",
                fontWeight: "bold",
              }}
            >
              Date of Birth
            </div>
            <div>
              <CustomTextInput
                textstyle={classes.labelTextInputTextStyle}
                design={classes.textInputContainer}
                fullWidth={true}
                value={this.state.datePicked}
                //onChange={this.onChangeOtpNo}
                disabled={true}
                errorMessage={errorMsgDOB}
                error={errorMsgDOB !== "" ? true : false}
                endAdornment={
                  <img
                    src={Image.scheduleApp}
                    style={{ height: "24px", cursor: "pointer" }}
                    onClick={this.openCalander}
                  />
                }
              />
            </div>
          </div>
        </div>
        {/* <div style={{marginTop:19}}>Yes, I agree with the terms and conditions</div> */}
        <div style={{ marginTop: 19 }}>
          {" "}
          <FormControlLabel
            control={
              <Checkbox
                //  {...(item.Value === "1" ?  setState({checkedA:true})  : )}
                checked={this.state.checkedA}
                onChange={this.handleChangeCheckedA}
                name="checkedA"
                color="white"
                classes={{
                  root: classes.checkboxSty,
                  checked: classes.checked,
                }}
              />
            }
            label={
              <span style={{ fontWeight: "bold", fontSize: "14px" }}>
                I have acknowledge and agreed to the
                <span
                  style={{
                    color: "rgba(22,81,29)",
                    textShadow: "0 0 3px #fff",
                  }}
                  onClick={this.handleShowTerms}
                >
                  &nbsp;terms and conditions
                </span>
              </span>
            }
          />
        </div>
        <div
          style={{
            marginTop: 20,
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            background: "#C9DC5D 0% 0% no-repeat padding-box",
            boxShadow: "0px 3px 6px #000000C1",
            borderRadius: "10px",
            width: "265px",
            alignSelf: "center",
            //height:"53px",
            paddingTop: 10,
            paddingBottom: 10,
            color: "#262626D1",
            fontSize: "22px",
            fontWeight: "bold",
            cursor: "pointer",
          }}
          onClick={this.submitDetails}
        >
          Submit Details
        </div>
      </div>
    );
  };

  onChangeOtp1 = (e) => {
    console.log("a", e.target.value, e.target.value.length);

    // let regex = /[^0-9][+-]?[0-9]{1,10}[^0-9]/;
    // if (regex.test(e.target.value)) {
    //     console.log("a!!",regex.test(e.target.value));
    //     this.setState({ otp1: e.target.value, second: true });
    // }

    if (e.target.value.length > this.state.localMaxLen) {
      var textbox = document.getElementById("edtunt2");
      textbox.focus();

      return;
    } else {
      this.setState({ otp1: e.target.value, second: true });
      var textbox = document.getElementById("edtunt2");
      textbox.focus();
    }

    if (e.target.value === "") {
      var textbox = document.getElementById("edtunt");
      textbox.focus();
    }
  };
  onChangeOtp2 = (e) => {
    if (e.target.value.length > this.state.localMaxLen) {
      //alert("AAA");
      // var textbox = document.getElementById("edtunt3");
      //  textbox.focus();
      return;
    } else {
      this.setState({ otp2: e.target.value, third: true });
      var textbox = document.getElementById("edtunt3");
      textbox.focus();
    }

    //alert("AAA", e.target.value);
    //console.log("ASd",e.target.value)
    if (e.target.value === "") {
      var textbox = document.getElementById("edtunt2");
      textbox.focus();
    }
  };
  onChangeOtp3 = (e) => {
    if (e.target.value.length > this.state.localMaxLen) {
      //   var textbox = document.getElementById("edtunt4");
      //   textbox.focus();
      return;
    } else {
      this.setState({ otp3: e.target.value, forth: true });
      var textbox = document.getElementById("edtunt4");
      textbox.focus();
    }
    //this.setState({ otp3: e.target.value, forth: true });

    if (e.target.value === "") {
      var textbox = document.getElementById("edtunt3");
      textbox.focus();
    }
  };
  onChangeOtp4 = (e) => {
    if (e.target.value.length > this.state.localMaxLen) {
      return;
    } else {
      this.setState({ otp4: e.target.value, fifth: true });
      var textbox = document.getElementById("edtunt5");
      textbox.focus();
    }

    if (e.target.value === "") {
      var textbox = document.getElementById("edtunt4");
      textbox.focus();
    }
  };
  onChangeOtp5 = (e) => {
    if (e.target.value.length > this.state.localMaxLen) {
      //   var textbox = document.getElementById("edtunt6");
      //   textbox.focus();
    } else {
      this.setState({ otp5: e.target.value, sixth: true });
      var textbox = document.getElementById("edtunt6");
      textbox.focus();
    }

    if (e.target.value === "") {
      var textbox = document.getElementById("edtunt5");
      textbox.focus();
    }
  };
  onChangeOtp6 = (e) => {
    if (e.target.value.length > this.state.localMaxLen) {
    } else {
      this.setState({ otp6: e.target.value });
    }

    if (e.target.value === "") {
      var textbox = document.getElementById("edtunt6");
      textbox.focus();
    }
  };

  autotab() {
    if (this.state.otp1) {
      this.setState({ second: true });
    }
  }

  onKeyDown = (e) => {
    console.log("asd");
    if (e.keyCode === 8) {
      console.log("delete");
      this.setState({ otp1: "" });
      //   if (this.state.otp1 !== "") {
      //     var textbox = document.getElementById("edtunt2");
      //     textbox.focus();
      //   }
    }
  };
  onKeyDown2 = (e) => {
    if (e.keyCode === 8) {
      console.log("delete");
      var textbox = document.getElementById("edtunt2");
      textbox.focus();
      this.setState({ otp2: "" });
      if (this.state.otp2 === "") {
        var textbox = document.getElementById("edtunt");
        textbox.focus();
      }
    }
  };
  onKeyDown3 = (e) => {
    if (e.keyCode === 8) {
      console.log("delete");
      var textbox = document.getElementById("edtunt3");
      textbox.focus();
      this.setState({ otp3: "" });
      if (this.state.otp3 === "") {
        var textbox = document.getElementById("edtunt2");
        textbox.focus();
      }
    }
  };
  onKeyDown4 = (e) => {
    if (e.keyCode === 8) {
      console.log("delete");
      var textbox = document.getElementById("edtunt4");
      textbox.focus();
      this.setState({ otp4: "" });
      if (this.state.otp4 === "") {
        var textbox = document.getElementById("edtunt3");
        textbox.focus();
      }
    }
  };
  onKeyDown5 = (e) => {
    if (e.keyCode === 8) {
      console.log("delete");
      var textbox = document.getElementById("edtunt5");
      textbox.focus();
      this.setState({ otp5: "" });
      if (this.state.otp5 === "") {
        var textbox = document.getElementById("edtunt4");
        textbox.focus();
      }
    }
  };
  onKeyDown6 = (e) => {
    if (e.keyCode === 8) {
      console.log("delete");
      var textbox = document.getElementById("edtunt6");
      textbox.focus();
      this.setState({ otp6: "" });
      if (this.state.otp6 === "") {
        var textbox = document.getElementById("edtunt5");
        textbox.focus();
      }
    }
  };

  renderChildrenV2 = () => {
    const { classes } = this.props;
    const {
      policyNo,
      isOnClickNext,
      errorMsg,
      error,
      otp1,
      otp2,
      otp3,
      otp4,
      otp5,
      otp6,
    } = this.state;
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          paddingLeft: window.innerWidth < 640 ? "5%" : "15%",
          paddingRight: window.innerWidth < 640 ? "5%" : "15%",
          paddingTop: "2%",
          fontFamily: "Arial",
        }}
      >
        <div
          style={{ color: "#262626", fontSize: "1.75rem", fontWeight: "600" }}
        >
          RSVP for WAKANDA FOREVER PREMIERE with ETIQA.
        </div>
        <div
          style={{
            color: "#262626",
            fontSize: "22px",
            fontWeight: "600",
            marginTop: 10,
          }}
        >
          We are excited and glad that you can join us!
        </div>

        <div
          style={{
            display: "flex",
            flexDirection: "column",
            paddingLeft: window.innerWidth < 640 ? "2%" : "15%",
            paddingRight: window.innerWidth < 640 ? "2%" : "15%",
            background: "#12485A 0% 0% no-repeat padding-box",
            boxShadow: "0px 10px 10px #00000065",
            borderRadius: "9px",
            marginTop: 20,
            paddingTop: 35,
            paddingBottom: 35,
          }}
        >
          <div style={{ color: "white" }}>
            Please key your OTP 6 digit number that is send to your registered
            mobile number with us.
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
              alignSelf: "center",
              marginTop: 15,
              width: "100%",
            }}
          >
            <div>
              {" "}
              <CustomTextInputOtp
                id="edtunt"
                ref={(input) => (this.input1 = input)}
                textstyle={classes.labelTextInputTextStyle}
                design={classes.textInputContainerV2}
                fullWidth={true}
                value={this.state.otp1}
                //placeholder={"Last 4 characters e.g. 234B"}
                onChange={this.onChangeOtp1}
                autoFocus={this.state.first}
                errorMessage={errorMsg}
                type={"password"}
                error={error}
                onKeyDown={this.onKeyDown}
                maxL={this.state.localMaxLen}
              />
            </div>
            <div style={{ marginLeft: 10, marginRight: 10 }}></div>
            <div>
              {" "}
              <CustomTextInputOtp
                id="edtunt2"
                ref={(input) => (this.input2 = input)}
                textstyle={classes.labelTextInputTextStyle}
                design={classes.textInputContainerV2}
                fullWidth={true}
                value={this.state.otp2}
                //placeholder={"Last 4 characters e.g. 234B"}
                onChange={this.onChangeOtp2}
                type={"password"}
                errorMessage={errorMsg}
                error={error}
                autoFocus={this.state.second}
                onKeyDown={this.onKeyDown2}
                maxL={this.state.localMaxLen}
              />
            </div>
            <div style={{ marginLeft: 10, marginRight: 10 }}></div>
            <div>
              {" "}
              <CustomTextInputOtp
                id="edtunt3"
                textstyle={classes.labelTextInputTextStyle}
                design={classes.textInputContainerV2}
                fullWidth={true}
                value={this.state.otp3}
                //placeholder={"Last 4 characters e.g. 234B"}
                onChange={this.onChangeOtp3}
                type={"password"}
                errorMessage={errorMsg}
                error={error}
                autoFocus={otp2 !== "" ? true : false}
                onKeyDown={this.onKeyDown3}
              />
            </div>
            <div style={{ marginLeft: 10, marginRight: 10 }}></div>
            <div>
              {" "}
              <CustomTextInputOtp
                id="edtunt4"
                textstyle={classes.labelTextInputTextStyle}
                design={classes.textInputContainerV2}
                fullWidth={true}
                value={this.state.otp4}
                type={"password"}
                //placeholder={"Last 4 characters e.g. 234B"}
                onChange={this.onChangeOtp4}
                errorMessage={errorMsg}
                error={error}
                autoFocus={otp3 !== "" ? true : false}
                onKeyDown={this.onKeyDown4}
              />
            </div>
            <div style={{ marginLeft: 10, marginRight: 10 }}></div>
            <div>
              {" "}
              <CustomTextInputOtp
                id="edtunt5"
                textstyle={classes.labelTextInputTextStyle}
                design={classes.textInputContainerV2}
                fullWidth={true}
                value={this.state.otp5}
                type={"password"}
                //placeholder={"Last 4 characters e.g. 234B"}
                onChange={this.onChangeOtp5}
                errorMessage={errorMsg}
                error={error}
                autoFocus={otp4 !== "" ? true : false}
                onKeyDown={this.onKeyDown5}
              />
            </div>
            <div style={{ marginLeft: 10, marginRight: 10 }}></div>
            <div>
              {" "}
              <CustomTextInputOtp
                id="edtunt6"
                textstyle={classes.labelTextInputTextStyle}
                design={classes.textInputContainerV2}
                fullWidth={true}
                value={this.state.otp6}
                type={"password"}
                //placeholder={"Last 4 characters e.g. 234B"}
                onChange={this.onChangeOtp6}
                errorMessage={errorMsg}
                error={error}
                autoFocus={otp5 !== "" ? true : false}
                onKeyDown={this.onKeyDown6}
              />
            </div>
          </div>
          <div
            style={{
              marginTop: 5,
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
              background: "#C9DC5D 0% 0% no-repeat padding-box",
              boxShadow: "0px 3px 6px #000000C1",
              borderRadius: "10px",
              width: "265px",
              alignSelf: "center",
              //height:"53px",
              paddingTop: 10,
              paddingBottom: 10,
              color: "#262626D1",
              fontSize: "22px",
              fontWeight: "bold",
              cursor: "pointer",
              marginTop: 25,
            }}
            onClick={this.handleEnterOtp}
          >
            Enter
          </div>
        </div>
      </div>
    );
  };

  renderChildrenV3 = () => {
    const { classes } = this.props;
    const { policyNo, isOnClickNext, errorMsg, error } = this.state;
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          paddingLeft: window.innerWidth < 640 ? "5%" : "15%",
          paddingRight: window.innerWidth < 640 ? "5%" : "15%",
          paddingTop: "2%",
          fontFamily: "Arial",
        }}
      >
        <div
          style={{ color: "#262626", fontSize: "1.75rem", fontWeight: "600" }}
        >
          RSVP for WAKANDA FOREVER PREMIERE with ETIQA.
        </div>
        <div
          style={{
            color: "#262626",
            fontSize: "22px",
            fontWeight: "600",
            marginTop: 10,
          }}
        >
          We are excited and glad that you can join us!
        </div>

        <div
          style={{
            display: "flex",
            flexDirection: "column",
            // paddingLeft: "15%",
            //paddingRight: "15%",
            background: "#12485A 0% 0% no-repeat padding-box",
            boxShadow: "0px 10px 10px #00000065",
            borderRadius: "9px",
            marginTop: 20,
            paddingTop: 50,
            paddingBottom: 60,
            // cursor: "pointer",
          }}
          // onClick={this.handleForthView}
        >
          {/* <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "flex-end",
              paddingTop: 15,
              paddingRight: 30,
              marginBottom: 20,
            }}
          >
            {" "}
            <img
              src={Image.plus}
              style={{ height: "22px", cursor: "pointer" }}
              onClick={this.handleShowTerms}
            />
          </div> */}
          <div
            style={{ color: "white", fontSize: "30px", textAlign: "center" }}
          >
            Thank you for your registration.
          </div>
          <div
            style={{
              color: "white",
              fontSize: "30px",
              textAlign: "center",
              marginTop: 10,
            }}
          >
            We will be in touch shortly via email.
          </div>
        </div>
      </div>
    );
  };

  renderChildrenV4 = () => {
    const { classes } = this.props;
    const { policyNo, isOnClickNext, errorMsg, error } = this.state;
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          paddingLeft: window.innerWidth < 640 ? "5%" : "15%",
          paddingRight: window.innerWidth < 640 ? "5%" : "15%",
          paddingTop: "6%",
          fontFamily: "Arial",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            paddingLeft: "5%",
            paddingRight: "5%",
            //background: "#12485A 0% 0% no-repeat padding-box",
            // boxShadow: "0px 10px 10px #00000065",
            // borderRadius: "9px",
            marginTop: 40,
            paddingTop: 60,
            paddingBottom: 60,
            color: "#262626",
            cursor: "pointer",
          }}
          onClick={this.handleBackToTop}
        >
          <div
            style={{
              color: "#262626",
              fontSize: "30px",
              textAlign: "center",
              fontWeight: "600",
            }}
            dangerouslySetInnerHTML={{
              __html: this.state.forthMsg,
            }}
          ></div>
          {/* <div
            style={{
              color: "#262626",
              fontSize: "30px",
              textAlign: "center",
              marginTop: 10,
              fontWeight: "600",
            }}
          >
            Thank you for your interest in our event!
          </div> */}
        </div>
      </div>
    );
  };

  onChangeNRIC = (e) => {
    const re = /^([a-zA-Z]){4}$/;
    if (e.target.value === "" || e.target.value.length < 5) {
      this.setState({ localNric: e.target.value, errorMsgNRIC: "" });
    }
  };

  confirmDateBtnClick = () => {
    this.setState({
      datePicked: format(this.state.selected, "PP"),
      showCalander: false,
      errorMsgDOB: "",
    });
  };

  scheduleCallBackDatePicker = (date) => {
    const { selected, diabledDate, localDDateLists } = this.state;
    let footer = <p>Please pick a day.</p>;
    if (selected) {
      footer = <p>You picked {format(selected, "PP")}.</p>;
    }
    let confirmBtn = (
      <CustomButton
        disabled={selected ? false : true}
        style={{
          width: "70%",
          backgroundColor: selected ? "#00B4AF" : "#aaaaaa",
          color: selected ? "#fff" : "",
          border: "none",
          marginLeft: window.innerWidth < 700 ? 20 : 10,
          textTransform: "none",
        }}
        onClick={this.confirmDateBtnClick}
      >
        Confirm
      </CustomButton>
    );

    return (
      <div style={{ marginLeft: window.innerWidth < 700 ? "-9%" : "20%" }}>
        {/* {console.log("sssss", this.state.localDDateLists)} */}
        <DayPicker
          mode="single"
          selected={selected}
          onSelect={(selected) => this.setState({ selected: selected })}
          //fromMonth={new Date()}
          toDate={new Date(Date.now() + 12096e5)}
          // disabled={this.state.localDDateLists}
          fromYear={1900}
          toYear={new Date().getFullYear()}
          //onSelect={setSelected}
          captionLayout="dropdown"
          footer={footer}
        />
        {confirmBtn}
      </div>
    );
  };

  handleCloseTerms = () => {
    this.setState({ showTerms: false, showTermSub: false });
  };

  renderTermsAndCondition = () => {
    return (
      <div
        style={{
          fontFamily: "Arial",
          fontSize: "13px",
          paddingLeft: "5%",
          paddingRight: "7%",
          color: "#262626",
        }}
      >
        <div style={{ color: "#165163", fontSize: "22px", paddingLeft: 25 }}>
          Terms and Conditions
        </div>
        <div
          style={{
            color: "#165163",
            fontSize: "18px",
            fontWeight: "bold",
            marginBottom: 15,
            paddingLeft: 25,
          }}
        >
          Etiqa Customer Appreciation Movie Night – 11 November 2022
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "flex-start",
            textAlign: "left",
            marginBottom: 15,
            paddingLeft: 6,
          }}
        >
          <div>1.</div>
          <div style={{ paddingLeft: 13 }}>
            This Etiqa Customer Appreciation Movie Night (“Event”), organised by
            Etiqa Insurance Pte. Ltd. (“Etiqa”), is held on 11 November 2022
            (“Event Date”). The Event is free-of-charge.
          </div>
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "flex-start",
            textAlign: "left",
            marginBottom: 15,
            paddingLeft: 6,
          }}
        >
          <div>2.</div>
          <div style={{ paddingLeft: 13 }}>
            By registering (“Registration”) for the Event, you confirm that you
            have read, understood and agree to be bound by these Terms and
            Conditions, including any amendments thereto (the “T&Cs”).
          </div>
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "flex-start",
            textAlign: "left",
            marginBottom: 15,
            paddingLeft: 6,
          }}
        >
          <div>3.</div>
          <div style={{ paddingLeft: 13 }}>
            The Registration for the Event is open from 09:00 (Singapore Time)
            on 21 October 2022 to 23:59 (Singapore Time) on 6 November 2022
            (“Registration Period”).
          </div>
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "flex-start",
            textAlign: "left",
            marginBottom: 15,
            paddingLeft: 6,
          }}
        >
          <div>4.</div>
          <div style={{ paddingLeft: 13 }}>
            Registrations must be submitted during the Registration Period.
            Registrations submitted after the stated date and time will not be
            accepted.
          </div>
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "flex-start",
            textAlign: "left",
            marginBottom: 15,
            paddingLeft: 6,
          }}
        >
          <div>5.</div>
          <div style={{ paddingLeft: 13 }}>
            Registration for the Event is strictly by invitation only. You
            warrant that you have received a digital invitation (“Invitation”)
            directly from Etiqa between 21 October 2022 to 6 November 2022. Etiqa reserves the right to
            review and reject any registrations or person(s) who did not receive
            an Invitation to the Event.
          </div>
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "flex-start",
            textAlign: "left",
            marginBottom: 15,
            paddingLeft: 6,
          }}
        >
          <div>6.</div>
          <div style={{ paddingLeft: 13 }}>
            The Invitation cannot be forwarded and passed on to non-invited
            guests. Only individuals with an official invitation (“Invite
            Holder”) can register for the Event.
          </div>
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "flex-start",
            textAlign: "left",
            marginBottom: 15,
            paddingLeft: 6,
          }}
        >
          <div>7.</div>
          <div style={{ paddingLeft: 13 }}>
            Registration does not guarantee access to the Event venue (“Event
            Venue”) as tickets are given on a first-come-first-serve basis. The
            first 300 Invitation Holders who have successfully registered for
            the Event in accordance with the Invitation (“Confirmed Attendees”)
            will receive a confirmation email (“Confirmation”) by 6 November 2022 and be provided access to the Event Venue. Confirmed Attendees
            will be entitled to bring 1 (one) guest (“Guest”).
          </div>
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "flex-start",
            textAlign: "left",
            marginBottom: 15,
            paddingLeft: 6,
          }}
        >
          <div>8.</div>
          <div style={{ paddingLeft: 13 }}>
            The Confirmed Attendees who are present at the Event Venue on the
            Event Date will be entitled to receive the following from Etiqa
            (“Event Gifts”):
          </div>
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "flex-start",
            textAlign: "left",
            marginBottom: 15,
            paddingLeft: 30,
          }}
        >
          <div>8.1.1</div>
          <div style={{ paddingLeft: 13 }}>
            A Pair of Tickets to a Movie Screening (“Movie Tickets”) held on
            Event Date – Limited to 1 (one) pair per Confirmed Attendee. Etiqa
            reserves the right to not issue the second ticket to the guest who
            is absent at the event.
          </div>
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "flex-start",
            textAlign: "left",
            marginBottom: 15,
            paddingLeft: 30,
          }}
        >
          <div>8.1.2 </div>
          <div style={{ paddingLeft: 13 }}>
            Eco-Friendly Bag (“Eco Bag”) – Limited to 1 (one) redemption per
            Confirmed Attendee and 1 (one) for their Guest who is present at the
            Event Venue.
          </div>
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "flex-start",
            textAlign: "left",
            marginBottom: 15,
            paddingLeft: 30,
          }}
        >
          <div>8.1.3</div>
          <div style={{ paddingLeft: 13 }}>
            Popcorn and Bottled Water Combo (“Snack Combo”) – Limited to 1 (one)
            redemption per Confirmed Attendee only while stocks last.
          </div>
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "flex-start",
            textAlign: "left",
            marginBottom: 15,
            paddingLeft: 6,
          }}
        >
          <div>9.</div>
          <div style={{ paddingLeft: 13 }}>
            Etiqa reserves the right to amend the T&Cs at any time at our sole
            discretion, including changing the terms, substituting, withdrawing,
            adding or altering any of the Gifts or terminating the Event at any
            point in time before the stated Event Date without prior notice.
            Notice of any such amendments, cancellations or suspensions will be
            communicated to Confirmed Attendees via email.
          </div>
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "flex-start",
            textAlign: "left",
            marginBottom: 15,
          }}
        >
          <div>10.</div>
          <div style={{ paddingLeft: 13 }}>
            Confirmed Attendees should inform Etiqa should they not be able to
            attend the Event and would like to withdraw their attendance.
            Confirmed Attendees who withdraw their attendance will not be
            entitled to receive the Event Gifts.
          </div>
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "flex-start",
            textAlign: "left",
            marginBottom: 15,
          }}
        >
          <div>11. </div>
          <div style={{ paddingLeft: 13 }}>
            Confirmed Attendees and Guests (“Participants) of the Event are able
            to take part in a Photo Booth activity from 20:30 hrs to 21:30 hrs.
            (Singapore Time) on Event Date. Details of which are as follows:
          </div>
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "flex-start",
            textAlign: "left",
            marginBottom: 15,
            paddingLeft: 30,
          }}
        >
          <div>11.1.1</div>
          <div style={{ paddingLeft: 13, fontWeight: "bold" }}>
            GIF Photo booth
          </div>
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "flex-start",
            textAlign: "left",
            marginBottom: 15,
            paddingLeft: 60,
          }}
        >
          <div>i)</div>
          <div style={{ paddingLeft: 13 }}>
            Participants can take a photo at the GIF Photo Booth (“Photo
            Booth”). This is limited to a first-come-first-serve basis on the
            Event Date.
          </div>
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "flex-start",
            textAlign: "left",
            marginBottom: 15,
            paddingLeft: 60,
          }}
        >
          <div>ii)</div>
          <div style={{ paddingLeft: 13 }}>
            Participants will need to re-join the queue after each photo if they
            wish to take additional photos at the Photo Booth.
          </div>
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "flex-start",
            textAlign: "left",
            marginBottom: 15,
          }}
        >
          <div>12.</div>
          <div style={{ paddingLeft: 13 }}>
            {" "}
            By Registering and/or attending the Event, you acknowledge and
            consent that you may be photographed and/or filmed and that some of
            these photos and video recordings can be used for the minutes of
            Event, news, promotional purposes, future marketing materials,
            illustration, information and dissemination activities via Etiqa’s
            own websites or inclusion on Etiqa’s social media pages which may
            process personal data according to Etiqa’s own policies. Should you
            have any concerns about this, or do not wish to be featured in any
            of these materials, please approach the Event planner and inform
            him/her on the day of the Event. However, you are advised that
            incidental inclusion of some images of yourself within any recording
            or photos may take place. You also consent to Etiqa’s disclosure
            and/or use of your name and personal particulars given to Etiqa, for
            the purposes of the Event, and any publicity and promotional
            materials and activities related thereto.
          </div>
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "flex-start",
            textAlign: "left",
            marginBottom: 15,
          }}
        >
          <div>13.</div>
          <div style={{ paddingLeft: 13 }}>
            In the event of any inconsistency between these T&Cs and any
            advertising, publicity, brochure, marketing or other materials
            relating to or in connection with the Registration, Event or Photo
            Booth, these T&Cs shall prevail.
          </div>
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "flex-start",
            textAlign: "left",
            marginBottom: 15,
          }}
        >
          <div>14.</div>
          <div style={{ paddingLeft: 13 }}>
            {" "}
            Notwithstanding anything herein, Etiqa has the absolute discretion
            to determine the eligibility of any person to participate in the
            Registration, Event and/or Photo Booth.
          </div>
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "flex-start",
            textAlign: "left",
            marginBottom: 15,
          }}
        >
          <div>15.</div>
          <div style={{ paddingLeft: 13 }}>
            {" "}
            Etiqa’s decision on all matters relating to or in connection with
            the Event and Photo Booth, including Gifts to Confirmed Attendees
            and/or Guests, shall be final and binding on all parties concerned.
            Etiqa is not obliged to give any reason or enter into any
            correspondence with any person concerning the Gifts or Photo Booth.
          </div>
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "flex-start",
            textAlign: "left",
            marginBottom: 15,
          }}
        >
          <div>16.</div>
          <div style={{ paddingLeft: 13 }}>
            {" "}
            Etiqa shall not be liable for and assumes no liability or
            responsibility for any of the following: (a) non-performance or
            defects in the Gifts and photos taken at the Photo Booth and/or (c)
            any loss, damage, expense, liability and/or injury whatsoever or
            howsoever caused arising from the use, consumption and/or enjoyment
            of the Photo Booth and of the Gifts at the Event Venue.
          </div>
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "flex-start",
            textAlign: "left",
            marginBottom: 15,
          }}
        >
          <div>17.</div>
          <div style={{ paddingLeft: 13 }}>
            {" "}
            If Etiqa subsequently determines that a person is in fact not
            eligible to participate in this Registration and/or Event, for any
            reason whatsoever, Etiqa may at its discretion, disqualify that
            person and withdraw the Invitation and/or Confirmation without prior
            notice.
          </div>
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "flex-start",
            textAlign: "left",
            marginBottom: 15,
          }}
        >
          <div>18.</div>
          <div style={{ paddingLeft: 13 }}>
            {" "}
            By participating in the Event and the Photo Booth, the Participants
            agrees to release and hold Etiqa harmless from any and all liability
            whatsoever for any injuries, losses or damages of any kind to any
            person or property arising from or in connection with, either
            directly or indirectly the participation in the Event and Photo
            Booth at the Event Venue.
          </div>
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "flex-start",
            textAlign: "left",
          }}
        >
          <div>19.</div>
          <div style={{ paddingLeft: 13 }}>
            {" "}
            The T&Cs of the Event shall be governed by and interpreted in
            accordance with Singapore law. The courts of Singapore shall have
            exclusive jurisdiction over any disputes arising from the T&Cs,
            including the validity and enforceability thereof.
          </div>
        </div>
        <div style={{ marginTop: 15, paddingLeft: 28 }}>
          All information is correct as of 31 October 2022.
        </div>

        {this.renderTermsAndConditionSubmission()}
      </div>
    );
  };

  //   handleChangeCheckedB = ()=> {
  //     this.setState({checkedA:!this.state.checkedA})
  //   }

  renderTermsAndConditionSubmission = () => {
    const { classes } = this.props;
    return (
      <div
        style={{
          paddingLeft: "2.7%",
          paddingRight: "5%",
          fontSize: "13px",
          fontFamily: "Arial",
          color: "#262626",
          marginTop: "2%",
        }}
      >
        <div style={{ marginBottom: 20 }}>
          By submitting this form, you hereby agree that Etiqa Insurance Pte.
          Ltd. (EIPL) and Maybank Singapore (Maybank SG) may collect, obtain,
          store and process your personal data that you provide in this form for
          the purpose of receiving updates and communications from EIPL.
        </div>
        <div>You hereby give your consent to EIPL and Maybank SG to:</div>
        <div>• Store and process your Personal Data</div>
        <div style={{ marginTop: 10 }}>
          • Disclose your Personal Data to the relevant governmental authorities
          or third parties where required by law or for legal purposes.
        </div>
        <div style={{ marginTop: 10 }}>
          • Contact you to provide you with information on any updates or news
          pertaining to Etiqa Customer Appreciation Movie Night via the
          following modes of communications:
        </div>
        <div style={{ marginTop: 10, marginLeft: 10 }}>
          - postal mail to your address(es) and/ or electronic transmission to
          your email address(es);
        </div>
        <div style={{ marginTop: 5, marginLeft: 10 }}>
          - to your Singapore telephone number(s) that you have provided or may
          provide to EIPL and Maybank SG.{" "}
        </div>
        <div style={{ marginTop: 10 }}>
          You hereby confirm that you are the user and/ or subscriber of the
          telephone number(s) that you have provided or may provide to EIPL and
          Maybank SG.
        </div>
        <div style={{ marginTop: 10 }}>
          For more information, you may refer to the Etiqa’s Data Protection
          Statement on Etiqa’s website.
        </div>
        <div
          style={{
            marginTop: 19,
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
          }}
        >
          {" "}
          <FormControlLabel
            control={
              <Checkbox
                //  {...(item.Value === "1" ?  setState({checkedA:true})  : )}
                checked={this.state.checkedA}
                onChange={this.handleChangeCheckedA}
                name="checkedA"
                color="white"
                classes={{
                  root: classes.checkboxStyV2,
                  checked: classes.checked,
                }}
              />
            }
            label={
              <span style={{ fontSize: "13px" }}>
                I have acknowledge and agreed to the terms and conditions.
              </span>
            }
          />
          <div>
            <CustomButton
              style={{
                background: "#C9DC5D 0% 0% no-repeat padding-box",
                boxShadow: "0px 3px 6px #000000C1",
                borderRadius: "10px",
                border: "none",
                textTransform: "none",
              }}
              onClick={this.handleCloseTerms}
            >
              Close
            </CustomButton>
          </div>
          {/* <div
            style={{
              background: "#C9DC5D 0% 0% no-repeat padding-box",
              boxShadow: "0px 3px 6px #000000C1",
              borderRadius: "10px",

              paddingTop: 10,
              paddingBottom: 10,
              color: "#262626D1",

              cursor: "pointer",
            }}
            onClick={this.submitDetails}
          >
            Close
          </div> */}
        </div>
      </div>
    );
  };

  onCloseSchedule = () => {
    this.setState({ showCalander: false });
  };

  openCalander = () => {
    this.setState({ showCalander: true });
  };

  handleCloseCustomToast = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    this.setState({ customToastStatus: false });
  };

  handleShowTermSub = () => {
    this.setState({ showTermSub: true });
  };

  handleCloseTermSub = () => {
    // if(this.state.checkedA){
    //     this.setState({showTermSub:false,showTerms:false})
    // }else{
    //     this.setState({showTermSub:false,showTerms:true})
    // }
    this.setState({ showTermSub: false, showTerms: false });
  };

  render() {
    const { classes } = this.props;
    const {
      height,
      width,
      firstRender,
      secondRender,
      thirdRender,
      forthRender,
    } = this.state;
    return (
      <div>
        <div className={classes.rootHead}></div>
        <div className={classes.root}>
          <Helmet>
            <title>Movie Event</title>
          </Helmet>
          {/* <div className={classes.headerStyle} style={{display:"inline-block"}}>
          <div  >
            <img src={Image.renewalHeader} style={{height:"42px"}} />
          </div>
          <div style={{textAlign:"center"}}>
            <CustomText design={classes.headerTextStyle}>
              Policy Renewal
            </CustomText>
          </div>
        </div> */}

          {/* {window.innerWidth < 601 ? (
          <CustomEnrolGiroNowV2
            children={this.renderChildren()}
            height={height}
            width={width}
          />
        ) : (
          false
        )} */}
          {/* {window.innerWidth > 600 ? (
          <AppBar
            position="sticky"
            className={classes.appBar}
            style={{ background: "#333333" }}
          >
            <Toolbar
              className={classes.toolbarStyle}
              style={{
                justifyContent: "space-between",
                //alignItems: "center",
                display: "flex-start",
                flexDirection: "row",
                marginLeft: "5em",
              }}
            >
              <img
                src={Image.nonDirectClientEtiqaLogo}
                style={{ width: 112, height: 37 }}
              />
            </Toolbar>
          </AppBar>
        ) : (
          false
        )} */}
          {/* {window.innerWidth > 600 ? this.renderChildren() : false} */}
          {firstRender
            ? this.renderChildrenV1()
            : secondRender
            ? this.renderChildrenV2()
            : thirdRender
            ? this.renderChildrenV3()
            : forthRender
            ? this.renderChildrenV4()
            : this.renderChildrenV1()}
          {/* {this.renderChildrenV3()} */}

          {this.props.validateMovieRegLoading ||
          this.props.submitMovieRegLoading ? (
            <LoadingOverlay loading={true} />
          ) : (
            false
          )}

          <CustomModal
            open={this.state.showCalander}
            handleClose={this.onCloseSchedule}
            // loading={
            //   getScheduleCallBackLoading ||
            //   getDisabledTimeListsLoading ||
            //   createAppointmentLoading
            // }
            // modalTitle={"Schedule Date"}
            isTitleCenter
            titlestyle={classes.modalTitleStyle}
            modalDesign={window.innerWidth < 700 ? classes.modalDesignV : ""}
            //submitButtonText={"Confirm"}
            modalComponent={this.scheduleCallBackDatePicker()}
            disableBackdropClick
            //handleSubmitButton={this.onClickConfirmReview}
            isWhiteCloseIcon={false}
            buttonStyle={{ justifyContent: "center" }}
          />

          <CustomModal
            open={this.state.showTerms}
            handleClose={this.handleCloseTerms}
            // loading={
            //   getScheduleCallBackLoading ||
            //   getDisabledTimeListsLoading ||
            //   createAppointmentLoading
            // }
            // modalTitle={"Schedule Date"}
            isTitleCenter
            titlestyle={classes.modalTitleStyle}
            modalDesign={
              window.innerWidth < 700
                ? classes.modalDesignV
                : classes.termConModal
            }
            //submitButtonText={"Confirm"}
            modalComponent={this.renderTermsAndCondition()}
            disableBackdropClick
            //handleSubmitButton={this.onClickConfirmReview}
            isWhiteCloseIcon={false}
            buttonStyle={{ justifyContent: "center" }}
            isMovieCloseBtn={true}
          />

          <CustomModal
            open={this.state.showTermSub}
            handleClose={this.handleCloseTermSub}
            // loading={
            //   getScheduleCallBackLoading ||
            //   getDisabledTimeListsLoading ||
            //   createAppointmentLoading
            // }
            // modalTitle={"Schedule Date"}
            isTitleCenter
            titlestyle={classes.modalTitleStyle}
            modalDesign={
              window.innerWidth < 700
                ? classes.modalDesignV
                : classes.termConModalV2
            }
            //submitButtonText={"Confirm"}
            modalComponent={this.renderTermsAndConditionSubmission()}
            disableBackdropClick
            //handleSubmitButton={this.onClickConfirmReview}
            isWhiteCloseIcon={false}
            buttonStyle={{ justifyContent: "center" }}
            isMovieCloseBtn={true}
          />

          <CustomToast
            open={this.state.customToastStatus}
            handleCloseCustomToast={this.handleCloseCustomToast}
            title={this.state.toastMessage}
            warning
          />
        </div>
      </div>
    );
  }
}

const styles = (theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: "#f4f4f4",
    maxHeight: "100vh",
    minHeight: window.innerWidth < 640 ? "100vh" : "70vh",
    //  backgroundImage: window.innerWidth < 601 ? false : `url(${Image.enrolGiroBg})`,
    //  backgroundSize:window.innerWidth < 601 ? false : `${screenW} ${screenH}`,
    //  backgroundPosition: window.innerWidth < 601 ? false : "bottom center",
    //  backgroundRepeat: window.innerWidth < 601 ? false :"no-repeat",
    backgroundImage: `url(${Image.movieImgV2})`,
    backgroundSize: `${screenW} ${screenH}`,
    backgroundPosition: "bottom center",
    backgroundRepeat: "no-repeat",
    //overflow:"scroll"
  },
  rootHead: {
    flexGrow: 1,
    backgroundColor: "#f4f4f4",
    //  maxHeight: "100vh",
    minHeight: "30vh",
    //  backgroundImage: window.innerWidth < 601 ? false : `url(${Image.enrolGiroBg})`,
    //  backgroundSize:window.innerWidth < 601 ? false : `${screenW} ${screenH}`,
    //  backgroundPosition: window.innerWidth < 601 ? false : "bottom center",
    //  backgroundRepeat: window.innerWidth < 601 ? false :"no-repeat",
    backgroundImage: `url(${Image.movieImg})`,
    backgroundSize: `${screenWHead} ${screenHHead}`,
    backgroundPosition: "bottom center",
    backgroundRepeat: "no-repeat",
  },
  bottomImageStyle: {
    width: 20,
    height: 20,
    marginRight: 10,
    color: Color.primaryTextColor,
  },
  labelTextInputTextStyle: {
    ...getFontWeight("400"),
    fontSize: "16px",
    color: "#424143",
    fontFamily: "Muli",
    textAlign: "center",
  },
  //   textInputContainer: {
  //     height: 35,
  //     marginTop: 7,
  //   },
  nextButtonStyle: {
    //width: 150,
    marginTop: 10,
    marginBottom: 10,
    height: 40,
    fontFamily: "Muli",
    fontSize: "18px",
  },
  nextTextStyle: {
    ...getFontWeight("bold"),
    ...getFontSize("medium"),
  },
  bottomTextStyle: {
    ...getFontSize("small"),
    color: Color.primaryTextColor,
    fontFamily: "Muli",
  },
  highLightedTextStyle: {
    color: "#1858b9",
    fontFamily: "Muli",
    ...getFontSize("small"),
    ...getFontWeight("600"),
    textDecoration: "underline",
    "&:hover": {
      cursor: "pointer",
    },
  },
  renewNowTextStyle: {
    fontWeight: "bold",
    fontFamily: "Muli",
    fontSize: 22,
    textAlign: "center",
    marginBottom: 10,
    marginTop: 10,
  },
  renewNowTextStyleV2: {
    ...getFontWeight("400"),
    fontSize: 17,
    textAlign: "center",
    fontFamily: "Muli",
    marginBottom: 45,
  },
  errorTextStyle: {
    color: "red",
  },
  backButton: {
    width: 120,
    marginTop: 0,

    borderColor: Color.primaryTextColor,
    backgroundColor: "transparent",
    color: Color.primaryTextColor,
    opacity: 0.6,
    "&:hover": {
      color: "white",
      backgroundColor: Color.blackButtonColor,
    },
    "&:focus": {
      color: "white",
      backgroundColor: Color.blackButtonColor,
      opacity: 1.0,
    },
  },
  backButtonTextStyle: {
    fontFamily: "Muli",
    ...getFontSize("medium"),
    ...getFontWeight("bold"),
  },
  headerStyle: {
    backgroundColor: "#5b5b5b",
  },
  headerTextStyle: {
    color: "white",
    textAlign: "center",
    fontSize: "28px",
  },
  paper: {
    // overflow: "auto",
    //backgroundColor: "#f4f4f4",
    fontFamily: "Muli",
    //marginTop: window.innerWidth < 601 ? false : "6%",
    marginLeft: window.innerWidth < 601 ? false : "30%",
    marginRight: window.innerWidth < 601 ? false : "30%",
  },
  textInputContainer: {
    width: "100%",
    height: "50px",
    backgroundColor: "rgba(255, 255, 255,0.6)",
    // opacity: "0.6",
    border: "none",
  },
  checkboxSty: {
    color: "white",
    //backgroundColor:"white",
    "&$checked": {
      //backgroundColor: "green",
    },
  },
  checkboxStyV2: {
    color: "black",
    //backgroundColor:"white",
    "&$checked": {
      //backgroundColor: "green",
    },
  },
  checked: {},
  textInputContainerV2: {
    width: "100%",
    backgroundColor: "white",
    textAlign: "center",
    padding: 0,
    margin: 0,
  },
  modalDesignV: {
    width: window.innerWidth * 0.96,
    marginBottom: 30,
    overFlow: "scroll",
    paddingLeft: 10,
    paddingRight: 10,
  },
  termConModal: {
    width: window.innerWidth * 0.8,
    height: window.innerHeight * 0.85,
    backgroundColor: "#EDF5F7",
  },
  termConModalV2: {
    width: window.innerWidth * 0.8,
    //  height: window.innerHeight * 0.85,
    backgroundColor: "#EDF5F7",
  },
});

function mapStateToProps(state) {
  return {
    validateMovieRegData: selector.validateMovieRegData(state),
    validateMovieRegLoading: selector.validateMovieRegLoading(state),
    validateMovieRegStatus: selector.validateMovieRegStatus(state),

    submitMovieRegData: selector.submitMovieRegData(state),
    submitMovieRegLoading: selector.submitMovieRegLoading(state),
    submitMovieRegStatus: selector.submitMovieRegStatus(state),
  };
}

function mapDispatchToProps(dispatch) {
  return {
    validateMovieReg: (nric, dob) =>
      dispatch(registrationAction.validateMovieReg(nric, dob)),

    submitMovieReg: (otp, otpReference) =>
      dispatch(registrationAction.submitMovieReg(otp, otpReference)),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles, { withTheme: true })(withRouter(MovieEvent)));
